// extracted by mini-css-extract-plugin
export default {"container":"Card_container__VCUXY","btn":"Card_btn__TREBL"};